/*                                      */

/**
 *
 *
 */
export const VERSION = '5.38.10';
export const PUBLIC_VERSION = '5';
